// to enable deep level flatten use recursion with reduce and concat
export function flatDeep<T>(arr: any, d = 1): T[] {
  return d > 0
    ? arr.reduce((acc: any[], val: any) => acc.concat(Array.isArray(val) ? flatDeep(val, d - 1) : val), [])
    : arr.slice();
}
